module.exports = __webpack_public_path__ + "static/media/logo_all_testnet.d33501a9.png";